import React, { useState } from "react";

// Styles
import SelectTimeModalContainer from "./SelectTimeModal.styles";

// Utils
import { useSettings } from "context/Settings.context";

// Components
import Button from "components/Common/Button/Button";
import Modal from "components/Common/Modal/Modal";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { TextField } from "@mui/material";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

interface Props {
    initialTime: Date | null;
    onClose: () => void;
    onSubmit: (time: Date) => void;
}

const SelectTimeModal = ({ initialTime, onClose, onSubmit }: Props) => {
    const { setToast } = useSettings();
    const [time, setTime] = useState<Date | null>(initialTime);

    const handleSubmit = () => {
        if (time) {
            onSubmit(time);
        } else {
            setToast({
                show: true,
                type: "error",
                message: "Please enter a time",
            });
        }
    };

    return (
        <SelectTimeModalContainer>
            <Modal onClose={onClose}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <div className="main">
                        <div className="text">
                            <h3>EDIT UPCOMING MEETINGS TIME (UK TIMEZONE)</h3>
                        </div>
                        <TimePicker
                            ampm={false}
                            value={time}
                            minutesStep={5}
                            onChange={setTime}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </div>

                    <div className="actions">
                        <Button text="CANCEL" color="flat" click={onClose} />
                        <Button text="SAVE" click={() => handleSubmit()} />
                    </div>
                </LocalizationProvider>
            </Modal>
        </SelectTimeModalContainer>
    );
};
export default SelectTimeModal;
